<template>
  <div class="box" :class="{ isActive }">
    <div class="top">
      <div class="title" v-html="props.boxTitle"></div>
      <DeployerUiSwitch
        :is-active="props.isActive"
        @click.prevent="emits('changeActive')"
      />
    </div>
    <div class="text" v-html="props.boxText"></div>

    <slot></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  boxTitle: {
    type: String,
    default: ''
  },
  boxText: {
    type: String,
    default: ''
  },
  isActive: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['changeActive'])
</script>

<style lang="scss" scoped>
.box {
  border-radius: 10px;
  border: 1px solid var(--field-stroke, rgba(255, 255, 255, 0.2));
  background: var(--field-bg, rgba(255, 255, 255, 0.05));
  padding: 20px;
  overflow: hidden;

  transition: border 0.2s, box-shadow 0.2s;

  :deep(path) {
    stroke: var(--Text, #000);
  }

  &.isActive {
    border: 1px solid var(--CTA-50, rgba(61, 110, 246, 0.5));
    box-shadow: 0px 0px 5px 0px rgba(80, 79, 228, 0.5);
  }

  &:hover {
    box-shadow: 0px 0px 5px 0px rgba(80, 79, 228, 0.5);
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.title {
  font-size: 1.5rem;
  opacity: 0.7;
  font-weight: 500;
}

.text {
  font-size: 1.3rem;
  line-height: 150%;
  letter-spacing: 0.13px;
  opacity: 0.7;
  margin-bottom: 20px;
}
</style>
